.ContainerButtons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 1;
}

.ButtonMyLocation {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
}

.MarkerCluster{
  display: flex; 
}

.TitleMarkerCluster{
  color: var(--primary);
  overflow: hidden;
  text-overflow: ellipsis;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: max-content;
  margin-left: 10px;
  text-decoration: none;
}

.DetailMarkerCluster{
  
  width: 160px;
  height: max-content;
  padding: 8px;
  
  border-radius: 5px;
  /* Markers */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.SwitchContainerCluster {
  padding: 4px;
  background-color: var(--colori-neutri-white);
  border-radius: 10px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--primary);
}

.LabelSwitch{
  margin-right: 8px;
}

.ButtonMyLocation:active {
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

@media (hover: hover) {
  .ButtonMyLocation:hover {
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.1) 100%
      ),
      #fff;
    box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  }
}

.ButtonMappe {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  margin-bottom: 16px;
  border: none;
}

.ButtonFiltersActive {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 10px;
  border: 1px solid var(--primary);
  background: var(--primary);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 1;
}

.ButtonFilters {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 10px;
  border: 1px solid var(--primary);
  background: var(--primary);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 1;
}

.ZoomIn {
  border-radius: 30px !important;
  background: var(--colori-neutri-white) !important;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 44px !important;
  height: 44px !important;
  border: none !important;
  margin-top: 8px !important;
  position: absolute !important;
  left: 8px !important;
  top: 0px !important;
  font-size: 22px !important;
  line-height: 0px !important;
  color: var(--primary) !important;
}

.ZoomOut {
  border-radius: 30px !important;
  background: var(--colori-neutri-white) !important;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 44px !important;
  height: 44px !important;
  font-size: 22px !important;
  border: none !important;
  margin-top: 8px !important;
  position: absolute !important;
  left: 8px !important;
  top: 48px !important;
  /* font-size: 30px; */
  color: var(--primary) !important;
}

.ButtonResetItalia {
  border-radius: 30px !important;
  background: var(--colori-neutri-white) !important;
  font-weight: normal !important;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 44px !important;
  height: 44px !important;
  border: none !important;
  margin-top: 8px !important;
  
  margin-bottom: 10px !important;
  font-size: 30px !important;
  color: var(--primary) !important;
  transition: all 0.3s ease-in-out !important;
  cursor: pointer !important;
  z-index: 1;
}



.LoadingButton {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  margin-bottom: 16px;
  border: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.DetailMarker {
  display: flex;
  width: 160px;
  height: max-content;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  /* Markers */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.PinMarker {
  position: absolute;
  bottom: -10px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  content: ' ';
  font-size: 0;
  line-height: 0;
  margin-left: -10px;
  width: 0;
}

.TitleMarker {
  color: var(--colori-neutri-white);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.TextMarker {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colori-neutri-white, #fff);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.Badge{
  position: absolute;
  top: -3px;
  right: -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--tertiary);
}
